export default __webpack_public_path__ + "static/media/Logo.eda0929d.png";